import { t } from 'i18next';

import { Flex, Image, Text } from '@olist/united';

import LoadingGif from '../../assets/imgs/olist-loading.gif';

const LoadingOlist = (props) => {
  return (
    <Flex
      flexDirection="column"
      height="100vh"
      justifyContent="center"
      alignItems="center"
      data-testid="loading-olist"
      {...props}
    >
      <Image src={LoadingGif} mb="12px" aria-hidden="true" alt={t`loading`} />
      <Text color="foundation.linkPrimary" fontWeight="600" textAlign="center">
        {t`carrying the next steps of your success...`}
      </Text>
    </Flex>
  );
};

export default LoadingOlist;
